import {
    useMemo,
} from 'react'
import moment from 'moment'
import clsx from 'clsx'
import Label from 'app/shared-components/Label'

import dateTimeStandardMask from 'app/utils/date/dateTimeStandardMask'

import useStyles from './StatusAge.style'

const defaultProps = {
    value: undefined,
    title: '',
}

const StatusAge = ({
    value,
    title,
}: {
    value?: number | string,
    title?: string,
}) => {
    const {
        classes,
    } = useStyles()

    const statusAgeTitle: string = useMemo(() => {
        if (value) {
            return (typeof value === 'number')
                ? `${moment(value * 1000).fromNow(true)}`
                : `${moment.utc(value, dateTimeStandardMask).local().fromNow(true)}`
        }
        return ''
    }, [value])

    return (
        <div data-testid="status-age">
            {title && (
                <Label
                    title={title}
                />
            )}
            <div
                className={clsx(classes.upperText, {
                    [classes.text]: title,
                })}
                data-testid="status-age-text"
            >
                {statusAgeTitle}
            </div>
        </div>
    )
}

StatusAge.defaultProps = defaultProps

export default StatusAge
